import { Injectable } from '@angular/core';
import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";
import { Capacitor } from '@capacitor/core';
import { logEvent } from 'firebase/analytics';

@Injectable({
  providedIn: 'root'
})
export class FirebaseAnalyticsService {

  private analytics: any;

  constructor() { }

  public setAnalyticsInstance(analytics: any) {
    this.analytics = analytics;
  }

  public setAnalyticsEvent = async (eventName: string, eventProperties: any) => {
    if (Capacitor.isNativePlatform()) {
      await FirebaseAnalytics.logEvent({
        name: eventName,
        params: eventProperties,
      });
    } else {
      // Web platform - use native Firebase Analytics
      if (this.analytics) {
        logEvent(this.analytics, eventName, eventProperties);
      }
    }
  };
}
